import { operatorApiFetch } from './apiService';

export const accessibleIpAddressService = {
  fetchList: async () => {
    const response = await operatorApiFetch('accessible_ip_addresses');
    return response.json();
  },

  get: async (id) => {
    const response = await operatorApiFetch(`accessible_ip_addresses/${id}`);
    return response.json();
  },

  create: async (data) => {
    const response = await operatorApiFetch('accessible_ip_addresses', {
      method: 'POST',
      body: JSON.stringify({ accessible_ip_address: data })
    });
    return response.json();
  },

  delete: async (id) => {
    const response = await operatorApiFetch(`accessible_ip_addresses/${id}`, {
      method: 'DELETE'
    });
    return response.json();
  },

  batchDelete: async (ids) => {
    const response = await operatorApiFetch('accessible_ip_addresses/batch_delete', {
      method: 'POST',
      body: JSON.stringify({ ids })
    });
    return response.json();
  },

  getCurrentIp: async () => {
    const response = await operatorApiFetch('accessible_ip_addresses/current_ip');
    return response.json();
  }
};

export default accessibleIpAddressService;
